import '../../../../assets/css/screens/admin/dashboard/blogs/AdminBlogs.css';
import React, { useContext, useState, useEffect } from "react";
import { BsSearch } from "react-icons/bs";
import { FiCalendar, FiEye, FiEdit2, FiTrash2, FiX } from "react-icons/fi";
import { MdOutlineImage } from "react-icons/md";
import { HiOutlinePhotograph } from "react-icons/hi";
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import TiptapEditor from '../../../../components/admin/dashboard/blogs/TipTapEditor';


const slugify = (text) =>
  text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const AdminBlogs = () => {
  const { baseUrl, baseUrlForFile ,authToken} = useContext(AppContext);

  const [blogs, setBlogs] = useState([]);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [blog_title, setBlog_Title] = useState('');
  const [url_slug, setUrl_Slug] = useState('');
  const [status, setStatus] = useState('Draft');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [keywords, setKeywords] = useState('');
  const [is_featured, setIs_Featured] = useState();


  const openAddModal = () => {
    setBlog_Title('');
    setUrl_Slug('');
    setStatus('Draft');
    setDescription('');
    setImage(null);
    setKeywords('');
    setIs_Featured('');
    setEditingId(null);
    setShowModal(true);
  };
const cleanHTML = (html) => {
  if (!html) return "";

  const txt = document.createElement("textarea");
  txt.innerHTML = html;

  const decoded = txt.value;

  // remove ALL HTML tags
  const textOnly = decoded.replace(/<[^>]*>/g, "");

  // clean spaces
  return textOnly.replace(/\s+/g, " ").trim();
};

  const openEditModal = (blog) => {
    setBlog_Title(blog.blog_title);
    setUrl_Slug(blog.url_slug);
    setStatus(blog.status);
    setDescription(blog.description);
    setImage(blog.image);
    setKeywords(blog.keywords);
    setIs_Featured(blog.is_featured)
    setEditingId(blog.id);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingId(null);
  };
  //create
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append('blog_title', blog_title);
    formData.append('url_slug', url_slug);
    formData.append('status', status);
    formData.append('description', description);
    formData.append('image', image);
    formData.append('keywords', keywords);
    formData.append('is_featured', is_featured);

    if (image instanceof File) {
  formData.append('image', image);
}

    axios.post(`${baseUrl}/admin/blogs`, formData, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  }).then((response) => {
      // console.log(localStorage.getItem("token"))
      viewBlogs();
      setLoading(false);
      closeModal();
      
      // alert('Blog added successfully!');




    })
      .catch((err) => {
        setLoading(false);
        console.log(err);

        alert("Server Error");
      });


  };
  //view
 const viewBlogs = () => {
  axios.get(`${baseUrl}/viewblogs`, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
  .then((response) => {
    
    console.log(response.data);

   
    setBlogs(response.data.blog || response.data.blogs || response.data);
  })
  .catch((error) => {
    console.log(error);
  });
};


  //update
  const updateBlog = () => {

    setLoading(true);
    const formData = new FormData();
    formData.append('id', editingId);
    formData.append('blog_title', blog_title);
    formData.append('url_slug', url_slug);
    formData.append('status', status);
    formData.append('description', description);
    formData.append('image', image);
    formData.append('keywords', keywords);
    formData.append('is_featured', is_featured);

    axios.post(`${baseUrl}/updateblogs`, formData,
      {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
      .then(() => {
        viewBlogs();
        setLoading(false);
        closeModal();
        alert('Blog updated successfully!');
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        alert('Network Error!');
      });

    // setBlogs((prev) =>
    //   prev.map((blog) =>
    //     blog.id === editingId
    //       ? { ...blog, blog_title, url_slug, status, description, image }
    //       : blog
    //   )
    // );

    // setLoading(false);
    // closeModal();

    // alert('Blog updated successfully!');
  };
  //delete
  const deleteBlog = (id) => {
    const formData = new FormData();
    formData.append('id', id);
    axios.post(`${baseUrl}/deleteblogs`, formData,
     {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
      .then(() => {
        viewBlogs();
        alert('Plan deleted successfully!');
      })
      .catch((error) => {
        console.log(error);
      });
    // setBlogs((prev) => prev.filter((blog) => blog.id !== id));
    // alert('Blog deleted successfully!');
  };

const filteredBlogs = (blogs || []).filter((blog) =>
  (blog.blog_title || '').toLowerCase().includes(search.toLowerCase()) ||
  (blog.author || '').toLowerCase().includes(search.toLowerCase())
);

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };

  useEffect(() => {
    viewBlogs();
  }, []);

  return (
    <div className="blogs-page">

      <div className="blogs-container">

        {/* HEADER */}
        <div className="blogs-header">

          <div>
            <h2 className="blogs-title">Blogs</h2>
            <p className="blogs-subtitle">Manage blog posts</p>
          </div>

          <div className="blogs-topbar">

            <div className="search-box">
              <BsSearch className="search-icon" />

              <input
                className="search-input"
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <button
              className="btn-new-post"
              onClick={openAddModal}
            >
              + New Post
            </button>

          </div>

        </div>

        {/* BLOG LIST */}
        <div className="blogs-list">

          {filteredBlogs.map((blog, i) => (
            

            <div
              key={blog.id}
              className="blog-card"
              style={{ animationDelay: `${i * 0.08}s` }}
            >

              <div className="blog-card-desktop">

                <div className="blog-thumb">

                  {blog.image ? (
                    <img
                      src={blog.image}
  alt={blog.blog_title}
                      className="blog-thumb-img"
                    />
                  ) : (
                    <MdOutlineImage className="blog-thumb-icon" />
                  )}

                </div>

                <div className="blog-info">

                  <h6 className="bc-title">{blog.blog_title}</h6>
<div className="bc-description">
  {cleanHTML(blog.description)}
</div>
                  {blog.keywords && (
  <div className="bc-keywords">
    {blog.keywords.split(',').map((keyword, index) => (
      <span key={index} className="bc-keyword-tag">
        {keyword.trim()}
      </span>
    ))}
  </div>
)}

                  <div className="bc-meta">

                    <span className="bc-author">
                      {blog.author}
                    </span>

                    <span className="bc-date">
                      <FiCalendar size={12} /> {blog.date}
                    </span>
                    <span className={`bc-status bc-status-${blog.status.toLowerCase()}`}>
                      {blog.status}
                    </span>

                  </div>

                </div>

                <div className="blog-actions">

                  {blog.views !== null && (
                    <span className="bc-views">
                      <FiEye size={14} /> {blog.views}
                    </span>
                  )}

                  <button
                    className="btn-edit"
                    onClick={() => openEditModal(blog)}
                  >
                    <FiEdit2 size={13} /> Edit
                  </button>

                  <button
                    className="btn-delete"
                    onClick={() => deleteBlog(blog.id)}
                  >
                    <FiTrash2 size={15} />
                  </button>

                </div>

              </div>

            </div>
          ))}

        </div>

        {/* EMPTY */}
        {blogs.length === 0 && (
          <div className="afq-empty">
            <MdOutlineImage size={40} />
            <p>No blogs added yet.</p>
          </div>
        )}

      </div>

      {/* MODAL */}
      {showModal && (

        <div className="bm-overlay" onClick={closeModal}>

          <div
            className="bm-box"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="bm-header">

              <span className="bm-title">
                {editingId ? "Edit Blog Post" : "New Blog Post"}
              </span>

              <button
                className="bm-close"
                onClick={closeModal}
              >
                <FiX size={18} />
              </button>

            </div>

            <div className="bm-body">

              <div className="bm-field">

                <label className="bm-label">
                  Blog Title
                </label>

                <input
                  className="bm-input"
                  type="text"
                  placeholder="Enter blog title"
                  value={blog_title}
                  onChange={(e) => {
                    setBlog_Title(e.target.value);
                    setUrl_Slug(slugify(e.target.value));
                  }}
                />

              </div>

              <div className="bm-field">

                <label className="bm-label">
                  URL Slug
                </label>

                <input
                  className="bm-input bm-slug"
                  type="text"
                  placeholder="auto-generated-slug"
                  value={url_slug}
                  onChange={(e) => setUrl_Slug(e.target.value)}
                />

              </div>

              <div className="bm-field">

                <label className="bm-label">
                  Status
                </label>

                <select
                  className="bm-input"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option>Draft</option>
                  <option>Published</option>
                </select>

              </div>

 <div className="bm-field">
  <label className="bm-label">Description</label>

  <TiptapEditor
  value={description}
  onChange={setDescription}
/>
</div>

<div className="bm-field">

  <label className="bm-label">
    Keywords
  </label>

  <input
    className="bm-input"
    type="text"
    placeholder="Enter keywords separated by commas"
    value={keywords}
    onChange={(e) => setKeywords(e.target.value)}
  />

</div>

              <div className="bm-field">

                <label className="bm-label">
                  Featured Image
                </label>

                <label className="bm-upload-box">

                  {image ? (
                    <img
                      src={
                        typeof image === "string"
                          ? image
                          : URL.createObjectURL(image)
                      }
                      alt="preview"
                      className="bm-img-preview"
                    />
                  ) : (
                    <>
                      <HiOutlinePhotograph className="bm-upload-icon" />
                      <span className="bm-upload-text">
                        Click to upload image
                      </span>
                    </>
                  )}

                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImage}
                    style={{ display: "none" }}
                  />

                </label>

              </div>

            </div>

            <div className="bm-footer">

              <button
                className="btn-publish"
                onClick={
                  editingId
                    ? updateBlog
                    : handleSubmit

                }
                disabled={loading}
              >
                {loading
                  ? 'Please Wait...'
                  : editingId
                    ? 'Save Changes'
                    : 'Publish Post'}
              </button>

            </div>

          </div>

        </div>
      )}

    </div>
  );
};

export default AdminBlogs;